<template>
  <div>
    <div style="margin-bottom: 60px;">
      <div class="oilMain vux-1px-b vux-1px-t">
        <div class="vux-1px-b">
          <van-field
                  readonly
                  clickable
                  label="订购主体"
                  input-align="right"
                  :value="clientTypeName"
                  placeholder="请选择订购主体"
                  @click="showPicker = true"
          />
          <van-popup v-model="showPicker" round position="bottom">
            <van-picker
                    show-toolbar
                    :columns="typeList"
                    value-key="label"
                    @cancel="showPicker = false"
                    @confirm="onConfirm"
            />
          </van-popup>
        </div>
<!--        <div class="vux-1px-b">-->
<!--          <selector-->
<!--            title="订购主体"-->
<!--            direction="rtl"-->
<!--            placeholder="请选择订购主体"-->
<!--            v-model="params.clientType"-->
<!--            :options="typeList"-->
<!--          ></selector>-->
<!--        </div>-->
        <div class="vux-1px-b" @click="openShowPageList">
          <x-input
            title="买家"
            text-align="right"
            readonly
            placeholder="请选择买家"
            v-model="params.contactName"
            placeholder-align="right"
          >
          </x-input>
        </div>
        <div
          class="vux-1px-b"
          v-if="params.clientType == 2"
          @click="showContactList = true"
        >
          <x-input
            title="联系人"
            text-align="right"
            disabled="disabled"
            placeholder="请选择联系人"
            v-model="contactName"
            placeholder-align="right"
          >
          </x-input>
        </div>
        <div class="vux-1px-b" v-if="params.contactName">
          <x-input
            title="联系方式"
            text-align="right"
            disabled="disabled"
            placeholder="输入联系方式"
            v-model="params.contactPhone"
            placeholder-align="right"
          ></x-input>
        </div>
        <div class="vux-1px-b">
<!--          <selector-->
<!--            title="seller"-->
<!--            direction="rtl"-->
<!--            v-model="params.sellerId"-->
<!--            :options="supplyList"-->
<!--            @on-change="sellerChange"-->
<!--          ></selector>-->

          <van-field
                  readonly
                  clickable
                  label="seller"
                  input-align="right"
                  :value="sellerName"
                  placeholder="请选择订购主体"
                  @click="showSellerPicker = true"
          />
          <van-popup v-model="showSellerPicker" round position="bottom">
            <van-picker
                    show-toolbar
                    :columns="supplyList"
                    value-key="label"
                    @cancel="showSellerPicker = false"
                    @confirm="onSellerConfirm"
            />
          </van-popup>
        </div>

        <div
          class="vux-1px-b"
          v-for="(item, index) in exParamsList"
          :key="item.label"
        >
          <x-textarea
            v-if="item.label!='Seller'"
            :rows="1"
            :title="item.label"
            text-align="right"
            v-model="exParamsList[index].value"
            placeholder-align="right"
            autosize
          >
          </x-textarea>
        </div>

        <div
          class="vux-1px-b flex"
          v-for="(item, index) in addParamsList"
          :key="item.label"
        >
          <x-textarea
            class="flex1"
            :rows="1"
            :title="item.label"
            text-align="right"
            v-model="addParamsList[index].value"
            placeholder-align="right"
            autosize
          >
          </x-textarea>
          <img
            class="delImg"
            src="../../assets/del.png"
            @click="delParams(index)"
          />
        </div>
        <div class="addParams" @click="showPop = true">
          <img class="addImg" src="../../assets/add.png" />
        </div>
      </div>
    </div>
    <div class="footer flex">
      <div class="buyButton" @click="commitAdd">新增国际贸易订单</div>
    </div>

    <div v-transfer-dom>
      <popup v-model="showPop" height="180px" is-transparent>
        <div
          style="width: 95%;background-color:#fff;height:160px;margin:0 auto;border-radius:5px;padding-top:5px;"
        >
          <group title="添加参数">
            <cell title="参数名:">
              <input class="inputClass" v-model="paramsName" />
            </cell>
          </group>
          <div style="padding:20px 15px;">
            <x-button type="primary" @click.native="addNewParams"
              >添加</x-button
            >
          </div>
        </div>
      </popup>
    </div>

    <pageList
      class="customer"
      v-if="showPageList"
      :type="params.clientType"
      @change="onUserChange"
      @close="closeBox"
    ></pageList>

    <contactList
      class="customer"
      v-if="showContactList"
      :companyId="companyId"
      @change="contactChange"
      @close="closeContactList"
    ></contactList>
  </div>
</template>

<script>
import pageList from "@/components/pageList/pageList";
import contactList from "@/components/contactList/contactList";
import { getSupplyList, addNewOrder } from "../../api/newAdd";

export default {
  name: "newOrderI",
  props: {
    id: {
      type: String
    }
  },
  components: {
    pageList,
    contactList
  },
  data() {
    return {
      showPop: false,
      paramsName: "",
      show: false,
      typeList: [
        {
          value: "1",
          label: "个人"
        },
        {
          value: "2",
          label: "公司"
        }
      ],
      supplyList: [],
      params: {
        clientType: 1,
        companyId: "",
        contactClientId: "",
        sellerId: "",
        contactName: "",
        contactPhone: "",
        intentionDetails: []
      },
      exParamsList: [
        { label: "Seller", value: "", sort: 1 },
        { label: "Buyer", value: "", sort: 2 },
        { label: "Commodity", value: "", sort: 3 },
        { label: "Quantity", value: "", sort: 4 },
        { label: "Quality", value: "", sort: 5 },
        { label: "Delivery Terms", value: "", sort: 6 },
        { label: "Laycan", value: "", sort: 7 },
        { label: "Decimal Precision", value: "", sort: 8 },
        { label: "Price", value: "", sort: 9 },
        { label: "Payment", value: "", sort: 10 },
        { label: "Credit Term", value: "", sort: 11 },
        { label: "Storage/Hub", value: "", sort: 12 },
        { label: "Law and Arbitration", value: "", sort: 13 },
        { label: "Inspection", value: "", sort: 14 },
        { label: "Other terms and conditions", value: "", sort: 15 }
      ],
      addParamsList: [],
      showPageList: false,
      showContactList: false,
      contactName: "",
      clientId: "",
      companyId: "",
      checkType: "1",

      clientTypeName:'',
      showPicker:false,

      sellerName:'',
      showSellerPicker:false,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo;
    }
  },
  watch: {
    "params.clientType"() {
      this.params.contactName = "";
      this.params.contactPhone = "";
      this.companyId = "";
      this.contactName = "";
    }
  },
  created() {
    this.getSupplyList();
  },
  methods: {
    onConfirm(e){
      this.clientTypeName=e.label
      this.params.clientType=e.value
      this.showPicker=false
    },
    onSellerConfirm(e){
        this.sellerName=e.label
        this.exParamsList[0].value=e.label
        this.params.sellerId=e.value
        this.showSellerPicker=false
    },
    sellerChange(e){
      for(let i=0;i<this.supplyList.length;i++){
        if(this.supplyList[i].key==e){
          this.exParamsList[0].value=this.supplyList[i].value
        }
      }
    },
    getSupplyList() {
      getSupplyList()
        .then(res => {
          this.supplyList = res.map(item => {
            return {
              label: item.companyName,
              value: item.companyId
            };
          });
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    contactChange(e) {
      this.contactName = e.name;
      this.params.contactClientId = e.clientId;
      this.params.contactPhone = e.phone;
      this.showContactList = false;
    },
    closeContactList(state) {
      this.showContactList = state;
    },
    onUserChange(res) {
      this.showPageList = false;
      this.contactName = "";
      this.params.contactName = res.name;
      if (this.params.clientType == 1) {
        this.params.contactClientId = res.clientId;
        this.params.contactPhone = res.phone;
        this.companyId = "";
        this.params.companyId = "";
      } else {
        this.params.contactClientId = "";
        this.params.contactPhone = "";
        this.companyId = res.companyId;
        this.params.companyId = res.companyId;
      }
    },
    closeBox(state) {
      this.showPageList = state;
    },
    openShowPageList() {
      let that = this;
      document.activeElement.blur();
      that.showPageList = true;
      setTimeout(function() {
        that.showPageList = true;
      }, 200);
    },
    addNewParams() {
      if (this.paramsName) {
        this.addParamsList.push({
          label: this.paramsName,
          value: "",
          sort: ""
        });
        this.showPop = false;
        this.paramsName = "";
      } else {
        this.$showError("请输入参数名");
      }
    },
    delParams(index) {
      this.addParamsList.splice(index, 1);
    },
    commitAdd() {
      if (this.addParamsList.length > 0) {
        for (let i = 0; i < this.addParamsList.length; i++) {
          this.addParamsList[i].sort = 16 + i;
        }
      }
      this.params.intentionDetails = [
        ...this.exParamsList,
        ...this.addParamsList
      ];
      this.$vux.loading.show();
      addNewOrder(this.params)
        .then(res => {
          this.$vux.loading.hide();
          this.$router.push("/order/shareIntOrder/" + res.id);
        })
        .catch(err => {
          this.$vux.loading.hide();
          this.$showError(err);
        });
    }
  }
};
</script>

<style scoped lang="less">
.addParams {
  width: 100%;
  margin: 0 auto;
  padding: 10px 0;
}
.addImg {
  margin: 0 auto;
  display: block;
}
.delImg {
  width: 44px;
  height: 44px;
  margin: 20px 20px 20px 0;
}
.inputClass {
  border: none;
  height: 48px;
  line-height: 48px;
  text-align: right;
  display: inline-block;
  font-size: 16px;
}
.customer {
  position: fixed;
  top: -9px;
  left: 0;
  z-index: 2;
  width: 100%;
  overflow: hidden;
}
.yufu {
  display: inline-block;
  float: left;
  border: none;
  color: #ff3600;
  height: 100px;
  line-height: 100px;
  font-size: 16px;
  width: 200px;
}
.heji {
  display: block;
  overflow: hidden;
  padding: 20px 30px;
}
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
.x-oilBox {
  position: relative;
  background: #fff;
  margin: 10px 0;
  overflow: hidden;
  .border {
    background: url("../../assets/border.png") repeat;
    height: 1px;
    width: 100%;
  }
}
.middle {
  padding: 20px 30px;
}
.imgBox {
  width: 140px;
  height: 140px;
  overflow: hidden;
  margin-right: 30px;
}
.imgBox img {
  width: 100%;
  height: 100%;
  display: block;
}
.title {
  font-size: 16px;
  line-height: 32px;
  margin-bottom: 10px;
  color: #111111;
}
.spec {
  font-size: 12px;
  line-height: 32px;
  color: #919191;
  margin-bottom: 34px;
}
.money {
  font-size: 16px;
  color: #ff3600;
}

.oilMain {
  background: #fff;
  font-size: 14px;
  overflow: hidden;
  margin: 20px 0;
}
.oilText input {
  width: 100%;
  text-align: right;
  border: none;
  height: 40px;
  line-height: 40px;
}
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 1;
  width: 100%;
  height: 100px;
  background: #fff;
  line-height: 100px;
  border-top: 1px solid #e8e8e8;
}
.buyButton {
  width: 100%;
  height: 100px;
  background: #039df8;
  color: #fff;
  font-size: 15px;
  text-align: center;
}
.footerLine1 {
  margin-left: 30px;
  float: left;
}
.uploadImgBox {
  font-size: 14px;
  padding: 20px 30px;
}
.uploadImgBox img {
  margin-top: 20px;
  width: 300px;
  height: 200px;
  display: block;
  overflow: hidden;
}
</style>
